import { Card, Descriptions, type DescriptionsProps } from 'antd'

import { TrashIcon } from '@phosphor-icons/react'

import type { Product } from '../../../../../types'

type ProductUserCardProps = { product: Product; onRemoveProduct: (productId: string) => void }

export const ProductUserCard = ({ product, onRemoveProduct }: ProductUserCardProps) => {
    const items: DescriptionsProps['items'] = [
        {
            key: 'id',
            label: 'ID',
            children: product.id
        },
        {
            key: 'label',
            label: 'label',
            children: product.label
        }
    ]

    return (
        <Card style={{ width: 300 }} actions={[<TrashIcon key="edit" onClick={() => onRemoveProduct(product.id)} />]}>
            <Descriptions items={items} column={1} />
        </Card>
    )
}
